import React, { forwardRef } from 'react';
import { ReactNode } from 'react';
import Dropzone, { Accept, DropzoneRef } from 'react-dropzone';

type UploadDropboxProps = {
  label: string | ReactNode;
  className?: string;
  multiple: boolean;
  accept?: Accept;
  onDrop: (files: File[]) => void;
  onDialogCancel?: () => void;
  noClick?: boolean;
  isDisabled?: boolean;
  children: ReactNode;
  maxSize?: number;
  onDragLeave?: React.DragEventHandler<HTMLElement>;
  onDragEnter?: React.DragEventHandler<HTMLElement>;
};

export type UploadDropboxRef = DropzoneRef;

const DocUploadDropbox = forwardRef<UploadDropboxRef, UploadDropboxProps>(function UploadDropbox(
  {
    label,
    className,
    multiple,
    accept,
    isDisabled,
    children,
    noClick,
    onDrop,
    onDialogCancel,
    maxSize,
    onDragEnter,
    onDragLeave,
  },
  ref,
) {
  function handleOnDrop(files: File[]) {
    // this approach is better than using the native <Dropzone disabled>
    // because this prevents opening files in the new browser tab
    if (isDisabled) {
      return;
    }

    if (!files || !files.length) {
      return;
    }

    onDrop(files);
  }

  return (
    <Dropzone
      ref={ref}
      multiple={multiple}
      accept={accept}
      onDrop={handleOnDrop}
      noClick={noClick}
      onFileDialogCancel={onDialogCancel}
      maxSize={maxSize}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
    >
      {({ getRootProps, getInputProps }) => (
        <section {...getRootProps()} className={className}>
          <input {...getInputProps()} />
          {children}
          {label}
        </section>
      )}
    </Dropzone>
  );
});

export default DocUploadDropbox;
